// Segment identifiers for sources
const EMAIL = 'EMAIL';
const WEB_PUSH_NOTIFICATION = 'WEB_PUSH_NOTIFICATION';
const OFFERS_LIST_PAGE = 'OFFERS_LIST_PAGE';

// Source names
const SOURCES = {
  EMAIL_SOURCE: 'email',
  WEB_PUSH_NOTIFICATION_SOURCE: 'webpush',
  OFFERS_LIST_PAGE_SOURCE: 'offers_list'
};

const SEGMENT_SOURCES_MAP = {
  [SOURCES.EMAIL_SOURCE]: EMAIL,
  [SOURCES.WEB_PUSH_NOTIFICATION_SOURCE]: WEB_PUSH_NOTIFICATION,
  [SOURCES.OFFERS_LIST_PAGE_SOURCE]: OFFERS_LIST_PAGE
};

export { SOURCES, SEGMENT_SOURCES_MAP };
